module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/item_06_7a705f2b6551efc4c65f545272584e5a.jpg";